import { Injectable } from '@angular/core'

const STORAGE_KEY = 'aqsDevCustomer'

/**
 * Local-dev tenant picker. Reads `?customer=<shortname>` from the URL on
 * construction, persists it to sessionStorage, and strips the param from
 * the address bar. Apollo and HttpInterceptor read `current()` and attach
 * it as `X-Dev-Tenant` so the server-side tenantContext middleware can
 * resolve the tenant for unauthenticated requests (login mutations).
 *
 * After login, the JWT carries clientId and the server ignores this header.
 * The dev flow at `localhost:4200/?customer=demo` is purely for replacing
 * the prod Host-based resolution that doesn't work behind the dev proxy.
 */
@Injectable({ providedIn: 'root' })
export class DevTenantService {
  constructor() {
    const params = new URLSearchParams(window.location.search)
    const customer = params.get('customer')
    if (customer) {
      window.sessionStorage.setItem(STORAGE_KEY, customer)
      params.delete('customer')
      const qs = params.toString()
      const newUrl =
        window.location.pathname + (qs ? `?${qs}` : '') + window.location.hash
      window.history.replaceState({}, '', newUrl)
    }
    // Mirror the chosen tenant into a cookie so browser-originated requests
    // (e.g. `<img src="/files/...">`) carry it too — Apollo/HttpClient send
    // headers, but raw element fetches don't. Server-side tenantContext
    // reads this cookie as a fallback when X-Dev-Tenant isn't present.
    const stored = window.sessionStorage.getItem(STORAGE_KEY)
    if (stored) {
      document.cookie = `${STORAGE_KEY}=${encodeURIComponent(
        stored,
      )}; path=/; SameSite=Lax`
    }
  }

  current(): string | null {
    return window.sessionStorage.getItem(STORAGE_KEY)
  }
}
